module.exports = __webpack_public_path__ + "june-24-4.jpg?76f3654a330420ec74b24f067ea39d45";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/june-24-4.jpg
// module id = 219
// module chunks = 0